/*
 *  I15TEMPLIMITBOISCalcul.ts
 *
 *  Created by Sébastien Hecart on 2022-06-18 14:40:44 +0000.
 *  Copyright © 2022 Sebastien Hecart - Fahbe Company - . All rights reserved.
 *
 */

import { I15TEMPLIMITBOIS_State } from '@batical/types/src'

function I15TEMPLIMITBOIS_docalcul(state: I15TEMPLIMITBOIS_State) {
  //=IF(C5-C7*C6/(C4/(C5-C8))>=C8;IF(C8>=C5;"Températures ou puissances non valides";C5-C7*C6/(C4/(C5-C8)));"Températures ou puissances non valides")

  const { in_deperdition, in_temp_consigne, in_puissance_chaudiere, in_modulation_min, in_tempExtBase } = state
  if (in_tempExtBase >= in_temp_consigne) {
    state.res_tempReleveAppoint = NaN
    return state
  }
  const temp_result =
    in_temp_consigne - ((in_modulation_min / 100) * in_puissance_chaudiere) / (in_deperdition / (in_temp_consigne - in_tempExtBase))

  if (temp_result < in_tempExtBase) {
    state.res_tempReleveAppoint = NaN
    return state
  }
  state.res_tempReleveAppoint = temp_result
  return state
}

export default I15TEMPLIMITBOIS_docalcul
